<template>
  <v-col class="mt-3">
    <!-- Add item form -->
    <v-row>
      <v-form ref="addItemForm" v-if="layout !== 'correction' && invoiceType !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value">
        <v-row style="margin-top: 10px !important; margin-bottom: 10px !important">
          <v-col cols="12" style="text-align: left; padding-top: 5px !important; padding-bottom: 5px !important">
            <v-btn color="primary" @click="showEstimationItemsModal" :class="$vuetify.breakpoint.mdAndUp ? null : 'mr-3'">
              <v-icon color="white" class="mr-2">add</v-icon>
              {{ languageData.invoiceForm.addFromEstimations }}
            </v-btn>
          </v-col>
          <v-col cols="12" style="text-align: left; padding-top: 5px !important; padding-bottom: 5px !important">
            <v-btn color="primary" @click="addFromTimeReports">
              <v-icon class="mr-2">add</v-icon>
              {{ languageData.addFromTimeReports }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-between">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12" class="text-left" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-bottom: 0 !important'">
            <v-combobox
              v-model="newInvoiceItem.name"
              :items="products"
              :loading="isProductsLoading"
              :search-input.sync="searchProduct"
              item-text="name"
              item-value="name"
              hide-no-data
              :label="languageData.labelsInvoice.productName"
              :placeholder="languageData.labelsInvoice.startTypingToSearch"
              :rules="[(v) => !!v || languageData.validateInvoiceItems.name_required]"
              return-object
              outlined
            ></v-combobox>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important; padding-bottom: 0 !important'">
            <v-row>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 6" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important; padding-bottom: 0 !important'">
                <v-text-field
                  v-model="newInvoiceItem.quantity"
                  :label="languageData.labelsInvoice.qty"
                  :rules="[(v) => !!v || languageData.validateInvoiceItems.quantity_required]"
                  type="number"
                  min="0" step="0.01"
                  outlined
              ></v-text-field>
              </v-col>
               <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 6" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important; padding-bottom: 0 !important'">
                  <v-select
                    :label="languageData.labelsInvoice.uom"
                    v-model="newInvoiceItem.uom"
                    :items="measureTypes"
                    :rules="[(v) => !!v || languageData.validateInvoiceItems.uom_required]"
                    item-value="value"
                    item-text="name"
                    outlined
                    return-object>
                  <template slot='selection' slot-scope='{ item }'>
                    {{ languageData.measureTypes[item.value] }}
                  </template>
                  <template slot='item' slot-scope='{ item }'>
                    {{ languageData.measureTypes[item.value] }}
                  </template>
                </v-select>
               </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 6" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important; padding-bottom: 0 !important'">
                <v-text-field
                    v-model="newInvoiceItem.price"
                    :label="languageData.labelsInvoice.price"
                    :rules="[(v) => !!v || languageData.validateInvoiceItems.price_required, v => ( v && v < 1000000000 ) || languageData.validateInvoiceItems.max_price]"
                    min="0" step="0.01"
                    type="number"
                    append-icon="euro"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 6" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important; padding-bottom: 0 !important'">
                <v-select
                    :disabled="!showVat()"
                    :label="languageData.invoiceForm.vat"
                    v-model="newInvoiceItem.vat"
                    :items="showVat() ? vatData : []"
                    item-value="abbr"
                    item-text="label"
                    :rules="showVat() ? [(v) => !!v || languageData.validateInvoiceItems.vat_required]: []"
                    outlined
                    return-object>
                  <template slot='selection' slot-scope='{ item }'>
                    {{ languageData.vatLabels[item.label] }}
                  </template>
                  <template slot='item' slot-scope='{ item }'>
                    {{ languageData.vatLabels[item.label] }}
                  </template>
                </v-select>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important; padding-bottom: 0 !important'">
                <v-text-field
                    v-model="newInvoiceItem.totalNet"
                    :label="languageData.labelsInvoice.totalNet"
                    :rules="[v => ( v && v < 1000000000 ) || languageData.validateInvoiceItems.max_total_net]"
                    disabled
                    outlined
                ></v-text-field>
              </v-col>
               <v-col :cols="$vuetify.breakpoint.mdAndUp ? 1 : 12" :class="$vuetify.breakpoint.mdAndUp ? null : 'text-right mb-10'" :style="$vuetify.breakpoint.mdAndUp ? null : 'padding-top: 0 !important'">
                <v-btn :fab="$vuetify.breakpoint.mdAndUp ? true : false" color="primary" @click="addInvoiceItem">
                    <v-icon dark>
                      mdi-plus
                    </v-icon>
                    {{ $vuetify.breakpoint.mdAndUp ? null : languageData.invoiceForm.addToInvoiceBtn }}
                  </v-btn>
               </v-col>
            </v-row> 
          </v-col>
        </v-row>
      </v-form>
    </v-row>
    <!-- Invoice items table -->
    <v-row>
      <v-data-table style="width: 100%"
                    :headers="layout !== 'correction' && invoiceType !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value ? headersInvoiceItems : headersForCorrection"
                    :items="invoiceItems"
                    item-key="index"
                    class="elevation-0"
                    :disable-sort="true"
                    ref="invoiceItemsTable"
                    mobile-breakpoint="0"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="showDeleteInvoiceItemModal(item)"
                  icon>
                <v-icon color="fontDefault">delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <template v-slot:item.name="{ item }">
          <template v-if="item.visibleInput || layout === 'correction'">
            <span :class="{ hoverNotAllowed: item.visibleInput || layout === 'correction'}">{{ item.number !== undefined ? item.number : '' }}&nbsp;{{ item.name }}</span>
          </template>
          <template v-else>
            <v-edit-dialog
                large
                @save="save"
                persistent
                :return-value.sync="item.name"
            > {{ item.number !== undefined ? item.number : '' }}&nbsp;{{ item.name }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
                </v-btn> 
              </template>
              <span>{{ languageData.labelsInvoice.edit }}</span>
            </v-tooltip>
              <template v-slot:input>
                <v-text-field
                    class="mt-5"
                    v-model="item.name"
                    :label="languageData.editProductName"
                    outlined
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
        </template>
        <template v-slot:item.quantity="{ item }">
          <template v-if="item.visibleInput">
            <span :class="{ hoverNotAllowed: item.visibleInput }">{{ parseFloat(item.quantity).toFixed(2) }}</span>
          </template>
          <template v-else>
            <v-edit-dialog
                large
                @save="saveTotal(item)"
                persistent
                :return-value.sync="item.quantity"
            > {{ parseFloat(item.quantity).toFixed(2) }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
                </v-btn> 
              </template>
              <span>{{ languageData.labelsInvoice.edit }}</span>
            </v-tooltip>
              <template v-slot:input>
                <v-text-field
                    class="mt-5"
                    v-model="item.quantity"
                    :label="languageData.editQuantity"
                    type="number"
                    step="0.01"
                    outlined
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
        </template>
        <template v-slot:item.uom="{ item }" v-if="layout !== 'correction' && invoiceType !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value">
          <template v-if="item.visibleInput">
            <span :class="{ hoverNotAllowed: item.visibleInput }">
              {{ typeof (item.uom) === "object" ? languageData.measureTypes[item.uom.value] : languageData.measureTypes[item.uom] }}
            </span>
          </template>
          <template v-else>
            <v-edit-dialog
                large
                @save="save"
                persistent
                :return-value="item.uom"
            > {{ typeof (item.uom) === "object" ? languageData.measureTypes[item.uom.value] : languageData.measureTypes[item.uom] }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
                </v-btn> 
              </template>
              <span>{{ languageData.labelsInvoice.edit }}</span>
            </v-tooltip>
              <template v-slot:input>
                <v-select
                    :label="languageData.labels.uom"
                    v-model="item.uom"
                    :items="measureTypes"
                    item-value="value"
                    item-text="name"
                    outlined
                    return-object>
                  <template slot='selection' slot-scope='{ item }'>
                    {{ languageData.measureTypes[item.value] }}
                  </template>
                  <template slot='item' slot-scope='{ item }'>
                    {{ languageData.measureTypes[item.value] }}
                  </template>
                </v-select>
              </template>
            </v-edit-dialog>
          </template>
        </template>
        <template v-slot:item.price="{ item }">
          <template v-if="item.visibleInput">
            <span :class="{ hoverNotAllowed: item.visibleInput }">{{ parseFloat(item.price).toFixed(2) }}</span>
          </template>
          <template v-else>
            <v-edit-dialog
                large
                @save="saveTotal(item)"
                persistent
                :return-value.sync="item.price"
            > {{ parseFloat(item.price).toFixed(2) }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
                </v-btn> 
              </template>
              <span>{{ languageData.labelsInvoice.edit }}</span>
            </v-tooltip>
              <template v-slot:input>
                <v-text-field
                    class="mt-5"
                    v-model="item.price"
                    :label="languageData.editPrice"
                    :rules="[v => ( v && v < 1000000000 ) || languageData.validateInvoiceItems.max_price]"
                    type="number"
                    step="0.01"
                    outlined
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
        </template>
        <template v-slot:item.totalNet="{ item }">
          {{ parseFloat(item.totalNet).toFixed(2) }}
        </template>
        <template v-slot:item.vat="{ item }">
          <template v-if="showVat()">
            <template v-if="item.visibleInput">
              <span :class="{ hoverNotAllowed: item.visibleInput }">{{ typeof (item.vat) === "object" ? languageData.vatLabels[item.vat.label] : languageData.vatLabels[item.label] }}</span>
            </template>
            <template v-else-if="layout === 'correction'">
              <span>{{ typeof(item.vat) === "number" ? parseVat(item.vat, item.isVat0Eu) : parseVat(item.vat.value, item.isVat0Eu) }}</span>
            </template>
            <template v-else-if="item.vat || item.vat === 0">
              <v-edit-dialog
                  large
                  @save="saveVat(item)"
                  persistent
                  :return-value="item.vat"
              >
                {{ typeof (item.vat) === "object" && item.vat.label !== undefined ? languageData.vatLabels[item.vat.label] : typeof(item.vat) === "number" ? parseVat(item.vat, item.isVat0Eu) : parseVat(item.vat.value, item.isVat0Eu) }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
                </v-btn> 
              </template>
              <span>{{ languageData.labelsInvoice.edit }}</span>
            </v-tooltip>
                <template v-slot:input>
                  <v-select
                      :label="languageData.invoiceForm.vat"
                      v-model="item.vat"
                      :items="vatData"
                      item-value="abbr"
                      item-text="label"
                      outlined
                      @change="changeVat(item)"
                      return-object>
                    <template slot='selection' slot-scope='{ item }'>
                      {{ languageData.vatLabels[item.label] }}
                    </template>
                    <template slot='item' slot-scope='{ item }'>
                      {{ languageData.vatLabels[item.label] }}
                    </template>
                  </v-select>
                </template>
              </v-edit-dialog>
            </template>
          </template>
          <template v-else>
            0%
          </template>
        </template>
        <template v-slot:item.vatCost="{ item }">
          <template v-if="showVat()">
            {{ parseFloat(item.vatCost).toFixed(2) }}
          </template>
          <template v-else>
            0
          </template>
        </template>
        <template v-slot:item.totalGross="{ item }">
          <template v-if="showVat()">
            {{ parseFloat(item.totalGross).toFixed(2) }}
          </template>
          <template v-else>
            {{ parseFloat(item.totalNet).toFixed(2) }}
          </template>
        </template>
      </v-data-table>
    </v-row>
    <v-row justify="end" class="text-right">
      <!-- Invoice summary -->
      <v-col md="6" cols="12" ref="invoiceSummary">
        <v-row justify="end" class="text-right">
          <v-col cols="12"/>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 7 : 9">
              <template v-if="showVat()">
                <p>{{ languageData.invoice.subtotal }}</p>
                <p>{{ languageData.invoice.tax }}</p>
                <p class="ma-0"><strong>{{ languageData.invoice.total }}</strong></p>
              </template>
              <template v-else>
                <p class="ma-0"><strong>{{ languageData.invoice.total }}</strong></p>
              </template>
            </v-col>
          <v-col :cols="$vuetify.breakpoint.xsOnly ? 5 : 3">
            <template v-if="showVat()">
              <p>
                {{ invoiceSubtotal }}
                <v-icon dense>
                  euro
                </v-icon>
              </p>
              <p>
                {{ invoiceTax }}
                <v-icon dense>
                  euro
                </v-icon>
              </p>
              <p class="ma-0"><strong>
                {{ invoiceTotal }}
                <v-icon dense>
                  euro
                </v-icon>
              </strong></p>
            </template>
            <template v-else>
              <p class="ma-0"><strong>
                {{ invoiceSubtotal }}
                <v-icon dense>
                  euro
                </v-icon>
              </strong></p>
            </template>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ModalInfo :headModal="languageData.labels.addFromEstimations" :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideEstimationItemsModal" :show-modal="isShowEstimationItemsModal">
      <template v-slot:body>
        <EstimateItemsTable :showVat="showVat()" :tableHeaders="headersInvoiceItems" :invoiceItems="invoiceItems"></EstimateItemsTable>
      </template>
    </ModalInfo>
    <ModalInfo
        @doOperation="deleteInvoiceItem(modalDeleteData)" 
        :isLoadingBtn="false" 
        :typeInfo="modalDeleteData.typeInfo" 
        :headModal="modalDeleteData.head" 
        :btnDisAgreeText="modalDeleteData.btnDisAgreeText" 
        :btnAgreeText="modalDeleteData.btnAgreeText" 
        :visDisAgreeBtn="true" @clicked="hideModalDelete" 
        :show-modal="isShowDeleteModal" 
        :text-modal="modalDeleteData.textInfo">
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideMeasurementTableModal" :show-modal="isShowMeasurementTableModal">
      <template v-slot:body>
        <MeasurementsTable :project="projectData ? projectData : null" isInvoiceForm :invoiceItems="invoiceItems"></MeasurementsTable>
        <v-row class="mt-3 ml-1" v-if="renderCreateMeasurementButton()">
          <v-tooltip top :disabled="projectData.hasEstimation">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn :disabled="!projectData.hasEstimation" style="color: #fff" @click="createMeasurement" color="primary">{{ languageData.btnCreateMeasurment }}</v-btn>
              </div>  
            </template>
            <span>{{ languageData.measurements.tooltip }}</span>
          </v-tooltip>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideTimeReportsTableModal" :show-modal="isShowTimeReportsTableModal">
      <template v-slot:body>
        <TimeReportsTable :project="projectData ? projectData : null" layout="invoiceForm"></TimeReportsTable>
      </template>
    </ModalInfo>
  </v-col>
</template>

<style src="./InvoiceItemsTable.scss" lang="scss"></style>

<script type="text/javascript">
import measureTypes from "../../../../enums/measureTypes";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import EstimateItemsTable from "../../../Estimate/components/EstimateItemsTable/EstimateItemsTable";
import vatSettlement from "../../../Projects/enums/VatSettlement";
import currency from "currency.js";
import moneyCalculationsHelper from "../../../../helpers/moneyCalculationsHelper";
import MeasurementsTable from "../../../Measurements/components/MeasurementsTable";
import invoiceTypeEnum from "../../enums/invoiceTypeEnum";
import TimeReportsTable from "../../../Projects/components/ProjectRelations/TimeReports/TimeReports.vue";

export default {
  name: "InvoiceItemsTable",
  components: {MeasurementsTable, ModalInfo, EstimateItemsTable, TimeReportsTable},
  props: {
    projectData: Object,
    layout: String,
    invoicePayment: [Object, Array],
    invoiceItemsData: Array,
    invoiceType: [String, Number]
  },
  data() {
    return {
      invoiceItems: [],
      measureTypes: measureTypes,
      isRowEdit: false,
      estimationItemsLoaded: false,
      newInvoiceItem: {
        name: '',
        uom: null,
        quantity: null,
        price: null,
        vat: null,
        vatCost: null,
        totalNet: 0.00,
        totalGross:0.00,
      },
      isVatPayer: null,
      vatSettlement: vatSettlement,
      moneyCalculationsHelper: moneyCalculationsHelper,
      modalDeleteData: {},
      isShowDeleteModal: false,
      isShowMeasurementTableModal: false,
      invoiceTypeEnum: invoiceTypeEnum,
      isShowTimeReportsTableModal: false,
      searchProduct: '',
    }
  },
  computed: {
    invoiceSubtotal: function () {
      if(this.invoiceItems.length > 0){
        if (this.invoiceType === invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value) {
          return ((this.invoiceItems.reduce((a, b) => ({totalNet: currency(a.totalNet).value + currency(b.totalNet).value})).totalNet) * -1).toFixed(2);
        } else {
          return (this.invoiceItems.reduce((a, b) => ({totalNet: currency(a.totalNet).value + currency(b.totalNet).value})).totalNet).toFixed(2);
        }    
      } else {
        return 0.00;
      }
    },
    invoiceTax: function () {
      if(this.invoiceItems.length > 0) {
        if (this.invoiceType === invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value) {
          return ((this.invoiceItems.reduce((a, b) => ({vatCost: currency(a.vatCost).value + currency(b.vatCost).value})).vatCost) * -1).toFixed(2)
        } else {
          return (this.invoiceItems.reduce((a, b) => ({vatCost: currency(a.vatCost).value + currency(b.vatCost).value})).vatCost).toFixed(2)
        }  
      } else {
        return 0.00;
      }
    },
    invoiceTotal: function () {
      return (currency(this.invoiceSubtotal).value + currency(this.invoiceTax).value).toFixed(2);
    },
    discountCost: function () {
      if(this.invoiceItems.length > 0 && this.invoicePayment) {
        let calcDiscount = this.invoicePayment.discount / 100;

        return currency(this.invoiceSubtotal).multiply(calcDiscount).value.toFixed(2);
      }
      return 0;
    },
    discountTax: function () {
      if(this.discountCost > 0) {
        if(this.showVat()) {
          let calcDiscount = this.invoicePayment.discount / 100;
          return currency(this.invoiceTax).multiply(calcDiscount).value.toFixed(2);
        } else {
          return 0;
        }
      }
      return 0;
    },

    ...mapState("getHeadersInvoiceItems", {
      headersInvoiceItems: state => state.headers
    }),
    ...mapState("updateVisibleEstimationItemsModal", {
      isShowEstimationItemsModal: state => state.isShowEstimationItemsModal
    }),
    ...mapState("getVat", {
      vatData: state => state.vat
    }),
    ...mapState("getInvoice", {
      invoice: state => state.dataReceive,
      invoiceLoaded: state => state.invoiceLoaded,

    }),
    ...mapState("getHeadersMeasurementItems", {
      headersMeasurementItems: state => state.headers
    }),

    ...mapState("getAllProducts", {
      products: state => state.products,
      isProductsLoading: state => state.isProductsLoading
    }),

    headersForCorrection() {
      const newHeaders = [];
      if(this.headersInvoiceItems.length > 0) {
        this.headersInvoiceItems.forEach(function(item) {
          if (item.value !== 'uom') {
            newHeaders.push(item);
          }
        });
        return newHeaders;
      }
      return [];
    }
  },
  watch: {
    newInvoiceItem: {
      deep: true,
      handler (val) {
        if (typeof val.name === 'object' && val.name) {      
          val.price = val.name.price;
          val.uom = val.name.uom;
          val.vat = this.vatData.find(el => el.value === val.name.vat);
          val.name = val.name.name;
        } else if (typeof val.name === 'object' && !val.name) {
          this.resetNewInvoiceItem();
        }
        if(val.price && val.quantity && val.vat && this.showVat()) {
          val.totalNet = this.moneyCalculationsHelper.itemTotalNetProduct(val.price, val.quantity);
          val.vatCost = this.moneyCalculationsHelper.itemVatCost(val.totalNet, val.vat.value);
          val.totalGross = this.moneyCalculationsHelper.itemTotalGrossProduct(val.totalNet, val.vatCost);
          val.isVat0Eu = val.vat.label === 'V_0_EU';
        } else if (val.price && val.quantity && !this.showVat()) {
          val.totalNet = this.moneyCalculationsHelper.itemTotalNetProduct(val.price, val.quantity);
          val.totalGross = val.totalNet;
          val.vat = null;
          val.isVat0Eu = false;
        }
      }
    },
    invoiceLoaded() {
      if (this.layout === 'correction') {
        this.prepareInvoiceData();
      }
    },
    searchProduct(search) {
      if (this.isProductsLoading) return
      if (!search || search.length < 3) {
        this.resetAllProducts();
      }
      if (search && search.length >= 3) this.getAllProductsRequest({search})
    }
  },
  methods: {
    ...mapActions("saveInvoice", ["prepareInvoiceItems"]),
    ...mapActions("updateVisibleEstimationItemsModal", ["updateVisibleEstimationItemsModal"]),
    ...mapActions("getEstimate", ["getEstimate"]),
    ...mapActions('getHeadersMeasurementItems', ["getHeadersMeasurementItemsRequest"]),
    ...mapActions("getMeasurements", ["getHeadersTable"]),
    ...mapActions("showEstimationModal", ["updateVisibleEstimationModal", "updateIsMeasurementState", "updateMeasurementEditId"]),
    ...mapActions("getHeadersTimeReportsProject", ["getHeadersTimeReportsProject"]),
    ...mapActions("getTimeReports", ["getTimeReports"]),
    ...mapActions("getAllProducts", ["getAllProductsRequest", "resetAllProducts"]),

    changeVat(item) {
      item.vat.label === 'V_0_EU' ? item.isVat0Eu = true : item.isVat0Eu = false;
    },

    addFromTimeReports() {
      this.isShowTimeReportsTableModal = true;
    },

    hideTimeReportsTableModal() {
      this.isShowTimeReportsTableModal = false;
    },

    renderCreateMeasurementButton() {
      const url = window.location.href;
      if (url.includes('projects/edit')) {
        return true;
      } else {
        return false;
      }
    },

    resetNewInvoiceItem() {
      this.newInvoiceItem = {
          name: '',
          uom: null,
          quantity: null,
          price: null,
          vat: {},
          vatCost: null,
          totalNet: 0.00,
          totalGross: 0.00,
          isVat0Eu: false,
        };
    },

    addInvoiceItem() {
      if(this.$refs.addItemForm.validate()){
        this.invoiceItems.push(this.newInvoiceItem);
        this.newInvoiceItem = {
          name: '',
          uom: null,
          quantity: null,
          price: null,
          vat: {},
          vatCost: null,
          totalNet: 0.00,
          totalGross: 0.00,
          isVat0Eu: false,
        };
        this.prepareInvoiceItems(this.invoiceItems);
        this.$refs.addItemForm.resetValidation();
        this.searchProduct = '';
        this.resetAllProducts();
      }
    },
    showEstimationItemsModal() {
      this.getEstimate({id: this.projectData.id});
      this.updateVisibleEstimationItemsModal(true);
    },
    showMeasurementsModal() {
      if(this.projectData !== null) {
        eventBus.$emit('searchMeasurements');
      }
      this.isShowMeasurementTableModal = true;
    },
    hideEstimationItemsModal() {
      this.updateVisibleEstimationItemsModal(false);
    },
    hideMeasurementTableModal() {
      this.isShowMeasurementTableModal = false;
    },
    hideModalDelete() {
      this.isShowDeleteModal = false;
    },
    showDeleteInvoiceItemModal(item) { 
      var language = this.languageData.modalDeleteInvoiceItem;
      item.typeInfo = 'red';
      item.head = language.head;
      item.btnDisAgreeText = language.btnDisAgreeText;
      item.btnAgreeText = language.btnAgreeText;
      item.textInfo = language.textInfo + ' ' + item.name;
      this.modalDeleteData = item;
      this.isShowDeleteModal = true;
    },
    deleteInvoiceItem(item) {
      this.invoiceItems.splice(this.invoiceItems.indexOf(item), 1);
      this.prepareInvoiceItems(this.invoiceItems);
      if (item.timeReportItemId) {
        eventBus.$emit('deleteTimeReportSummaryItem', item.timeReportItemId);
      }
    },
    resetInvoiceItems() {
      this.invoiceItems = [];
    },
    save() {
      return true;
    },
    saveTotal(item) {
      let invoiceItem = this.invoiceItems[this.invoiceItems.indexOf(item)];
      invoiceItem.totalNet = this.moneyCalculationsHelper.itemTotalNetProduct(item.price, item.quantity);
      this.saveVat(item);
      this.prepareInvoiceItems(this.invoiceItems);

    },
    saveVat(item) {
      this.invoiceItems[this.invoiceItems.indexOf(item)].vatCost = this.moneyCalculationsHelper.itemVatCost(item.totalNet, typeof(item.vat) === 'object' ? item.vat.value : item.vat);
      this.invoiceItems[this.invoiceItems.indexOf(item)].totalGross = this.moneyCalculationsHelper.itemTotalGrossProduct(item.totalNet, item.vatCost);
      item.isVat0Eu = typeof(item.vat) === 'object' ? item.vat.label === 'V_0_EU' : item.isVat0Eu;
    },
    showVat() {
      return this.isVatPayer === 'true' && (this.projectData.vat_settlement === vatSettlement[1].value || this.invoice.vatSettlement === vatSettlement[1].value);
    },
    assignDefaultVat() {
      this.newInvoiceItem.vat = this.vatData.find(({label}) => label === 'V_19');
    },
    parseVat(vat, isVat0Eu) {
      return vat.toFixed(0) + '%' + (isVat0Eu ? ' EU' : '');
    },
    createMeasurement() {
      this.getEstimate({id: this.projectData.id});
      
      this.updateVisibleEstimationModal(true);
      this.updateIsMeasurementState(true);
      this.updateMeasurementEditId(null);

      eventBus.$emit('openCreateMeasurementModal');
    },
    prepareInvoiceData() {
      this.invoiceItems = [];
      this.invoiceItems = this.invoice.invoiceItems;
      this.prepareInvoiceItems(this.invoiceItems);
    }
  },
  beforeMount() {
    this.isVatPayer = localStorage.getItem('companyIsVatPayer')
  },
  mounted() {
    if (this.layout === 'edit' && this.invoiceItemsData) {
      this.invoiceItems = [];
      this.invoiceItems = this.invoiceItemsData;
      this.prepareInvoiceItems(this.invoiceItems);
    }

    this.getHeadersTable({ creds: { language: this.getCurrentLanguage } });

    eventBus.$on("saveInvoiceSuccess", () => {
      this.resetInvoiceItems();
      this.prepareInvoiceItems(this.invoiceItems);
    });
    eventBus.$on("sendInvoiceSuccess", () => {
      this.resetInvoiceItems();
      this.prepareInvoiceItems(this.invoiceItems);
    });
    eventBus.$on("addEstimationItem", (data) => {
      if(data.isMeasurement) {
        data.item.quantity = Math.round(data.item.uom_to_fv * 100) / 100;
        data.item.isMeasurement = true;
        data.item.vat
      }
      data.item.totalNet = this.moneyCalculationsHelper.itemTotalNetProduct(data.item.price, data.item.quantity);
      data.item.vatCost = this.moneyCalculationsHelper.itemVatCost(data.item.totalNet, this.showVat() ? typeof data.item.vat === 'object' ? data.item.vat.value : data.item.vat : 0);
      data.item.totalGross = this.moneyCalculationsHelper.itemTotalGrossProduct(data.item.totalNet, data.item.vatCost);
      this.invoiceItems.push(data.item);
      this.prepareInvoiceItems(this.invoiceItems);
    });

    eventBus.$on('getVatSuccess', () => {
      this.assignDefaultVat();
    });

    eventBus.$on("closeCorrectionInvoice", () => {
      this.invoiceItems = [];
    })
    eventBus.$on('updateProjectSuccess', () => {
      this.resetInvoiceItems();
    })
  },
}
</script>
